export default [
  {
    path: '/device-list/:id/:typeId',
    name: 'device-list',
    component: () => import(/* webpackChunkName: "device-list" */ '@/views/device/List.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/device-view/:id',
    name: 'device-view',
    component: () => import(/* webpackChunkName: "device-view" */ '@/views/device/View.vue'),
    meta: { requiresAuth: true }
  }
]
